import { Link } from 'react-router-dom';

interface CategoryCardProps {
  name: string;
  slug: string;
  description: string;
  icon: string;
  color: string;
}

const colorMap: Record<string, { bg: string; text: string; hoverBg: string }> = {
  primary: {
    bg: 'bg-primary-100/60',
    text: 'text-primary-600',
    hoverBg: 'hover:bg-primary-100',
  },
  accent: {
    bg: 'bg-accent-100/60',
    text: 'text-accent-600',
    hoverBg: 'hover:bg-accent-100',
  },
  secondary: {
    bg: 'bg-secondary-100/60',
    text: 'text-secondary-600',
    hoverBg: 'hover:bg-secondary-100',
  },
};

export default function CategoryCard({ name, slug, description, icon, color }: CategoryCardProps) {
  const c = colorMap[color] || colorMap.primary;

  return (
    <Link
      to={`/category/${slug}`}
      className={`group flex flex-col items-start p-6 rounded-xl ${c.bg} border border-background-200/40 ${c.hoverBg} transition-all duration-300 cursor-pointer`}
    >
      <div className={`w-12 h-12 flex items-center justify-center rounded-full ${c.bg} ${c.text} mb-4 group-hover:scale-110 transition-transform duration-300`}>
        <i className={`${icon} text-xl`}></i>
      </div>
      <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
        {name}
      </h3>
      <p className="text-sm text-foreground-600 leading-relaxed">{description}</p>
    </Link>
  );
}